<script lang="ts" setup>
import { computed } from "vue";
import type { FormFieldset } from "@/shared/@types/FormFieldset";

withDefaults(
  defineProps<{
    id?: string;
    fieldsets?: Array<FormFieldset>;
    action?: string;
    novalidate?: boolean;
  }>(),
  {
    fieldsets: () => [{ slot: "default" }],
  },
);

const usedSlots = defineSlots<{
  default(): void;
  actions(): void;
}>();

const hasActions = computed(() => !!usedSlots.actions);

defineEmits<{
  (e: "submit", value: Event): void;
}>();
</script>

<template>
  <form
    :id="id"
    class="form"
    :novalidate="novalidate"
    @submit.prevent="$emit('submit', $event)"
  >
    <fieldset
      v-for="fieldset in fieldsets"
      :key="fieldset.slot"
      class="form--section"
    >
      <legend
        v-if="fieldset.title"
        class="form--legend"
      >
        {{ fieldset.title }}
      </legend>
      <slot :name="fieldset.slot as keyof typeof usedSlots"></slot>
    </fieldset>
    <div
      v-if="hasActions"
      class="form--actions"
    >
      <slot name="actions"></slot>
    </div>
  </form>
</template>

<style scoped>
@import "Form.css";
</style>
